// Navigation
jQuery(function ($) {
	let set = window.innerWidth > 1000;
	$('.js-nav').hover(function () {
		if (set) {
			$(this).addClass('is-active');
			$(this).find('.l-nav__sub-menu').stop().fadeIn(300);
		}

	}, function () {
		if (set) {
			$(this).removeClass('is-active');
			$(this).find('.l-nav__sub-menu').stop().fadeOut(300);
		}
	});

	document.querySelectorAll('.js-nav__spTrigger').forEach(trigger => {
		if (trigger.nextElementSibling.classList.contains('js-nav__spTarget')) {
			trigger.addEventListener('click', function (e) {
				if (!set) {
					e.preventDefault();
					e.stopPropagation();
					const trgr = e.target.closest('.js-nav__spTrigger');
					const wrapper = trgr.closest('.js-nav')
					const target = wrapper.querySelector('.js-nav__spTarget');

					if (wrapper.classList.contains('is-active')) {
						wrapper.classList.remove('is-active');
						jQuery(target).stop().slideUp();
					} else {
						wrapper.classList.add('is-active');
						jQuery(target).stop().slideDown();
					}
				}


			}, false);
		}
	});

	window.addEventListener('resize', function (e) {
		set = window.innerWidth > 1000;
	});
});


// // Menu on smartphone
// jQuery(function ($) {
// 	$('.l-hamburger').each(function () {
// 		$(this).click(function () {
// 			$(this).toggleClass('is-active');
// 			$('#drawer_layer').fadeToggle();
// 			$('body').toggleClass('drawer_open');

// 			if ($(this).hasClass('is-active')) {
// 				$(this).parent().find('nav').addClass('is-open');
// 				$(this).parent().find('nav').removeClass('is-close');
// 			} else {
// 				$(this).parent().find('nav').removeClass('is-open');
// 				$(this).parent().find('nav').addClass('is-close');
// 			}
// 		});
// 	});
// });

// Menu on smartphone
jQuery(function ($) {
	const $outerHamburger = $('header > .l-header__inner > .l-hamburger'); // 外側
	const $innerHamburger = $('.l-header__nav .l-hamburger'); // ナビ内
	const $nav = $('.l-header__nav');
	const $drawerBg = $('#drawer_layer'); // 背景（.drawer_bgの場合はここを変更）
	const $body = $('body');

	// 外側ハンバーガー → メニューを開く
	$outerHamburger.on('click', function () {
		if ($(this).hasClass('is-active')) return; // 二重クリック防止

		$(this).addClass('is-active toggle_active is-hidden'); // 開くときはトグル状態＋非表示
		$nav.addClass('is-open').removeClass('is-close');
		$drawerBg.fadeIn();
		$body.addClass('drawer_open');

		// ナビ内ハンバーガーをアクティブ化
		$innerHamburger.addClass('toggle_active');
	});

	// ナビを閉じる
	const closeNav = function () {
		$nav.removeClass('is-open').addClass('is-close');
		$drawerBg.fadeOut();
		$body.removeClass('drawer_open');

		// 外側のハンバーガーを元に戻す
		$outerHamburger.removeClass('is-active toggle_active is-hidden');

		// 内側のハンバーガーも解除
		$innerHamburger.removeClass('toggle_active');
	};

	// 内側ハンバーガー or 背景クリックで閉じる
	$innerHamburger.on('click', closeNav);
	$drawerBg.on('click', closeNav);
});

